// Aplica as preferências de acessibilidade persistidas antes do render
// para evitar flash de animações quando o usuário optou por desativá-las.
const STORAGE_KEY = "zappy.accessibility";

interface Prefs {
  fontScale: number;
  highContrast: boolean;
  reduceMotion: boolean;
}

const DEFAULT: Prefs = { fontScale: 1, highContrast: false, reduceMotion: false };

export const applyStoredAccessibilityPrefs = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const p: Prefs = raw ? { ...DEFAULT, ...JSON.parse(raw) } : DEFAULT;
    const root = document.documentElement;
    root.style.fontSize = `${p.fontScale * 100}%`;
    root.classList.toggle("high-contrast", p.highContrast);
    root.classList.toggle("reduce-motion", p.reduceMotion);
  } catch {
    /* ignore */
  }
};
